import React from "react";
import { Query } from "@apollo/client/react/components";
import Loader from "components/Loader/Loader";

const DefaultQuery = ({ query, variables = {}, children }) => (
  <Query query={query} variables={variables} fetchPolicy={"network-only"}>
    {({ loading, error, data, fetchMore, subscribeToMore }) => {
      if (loading) {
        return <Loader minHeight={500} col={"col-1"} size="circle-scale--sm" />;
      }
      if (error) {
        return <div>{error.message}</div>;
      }
      return children({ data, fetchMore, subscribeToMore });
    }}
  </Query>
);

export default DefaultQuery;
